import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Pagination,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocalStorage } from "../custom-hook/useLocalStorage";
import { OpenPendingMessageModalReducer } from "../redux/adityaReducer";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  GetAllSentMessages_Json_Redux,
  sonamConfirmMessage,
} from "../redux/api_helper";
import PendingMessageComponanat from "../user/pages/portal-messages/PendingMessageComponanat";
import CustomLoader from "../components/CustomLoader";
import SendIcon from "@mui/icons-material/Send";
import CheckIcon from "@mui/icons-material/Check";
import {
  ad_GetMultiReminderStatus_Json_Action,
  ad_SendMultiReminderEmail_Json_Action,
} from "../redux/dev_aditya_action";
import { LinearProgress } from "@mui/material";
import { toast } from "react-toastify";
import { DataGrid } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from "devextreme-react/cjs/data-grid";

const TableHeder = [
  "",
  "Subject",
  "Recepient",
  "Section",
  "Issued On",
  "Action",
];

const PendingMesssageModal = () => {
  const dispatch = useDispatch();
  const { OpenPendingMessageModal } = useSelector(({ aditya }) => aditya);
  const closeModal = () => dispatch(OpenPendingMessageModalReducer(false));

  const { getAllSentMessages, getAllSentMessagesLoding } = useSelector(
    (state) => state.docu
  );
  const pageSizes = [10, 20, 50];

  const [originalData, setOriginalData] = useState([]); // Holds unfiltered data
  const [filteredData, setFilteredData] = useState([]); // Holds filtered data
  const [currentPage, setCurrentPage] = useState(1); // Tracks the current page
  const [selectedItem, setSelectedItem] = useState([]);
  const [progress, setProgress] = useState([]);
  const [filterEnable, setFilterEnable] = useState(false);

  const [progressInPersent, setProgressInPersent] = useState(0);
  const progressRef = useRef(progress);

  const itemsPerPage = 10; // Number of items per page
  const objReq = useLocalStorage("accid");
  const sentObj = {
    accid: objReq.accid,
    email: objReq.email,
    password: objReq.password,
    ccode: "",
    emailAddress: "",
  };

  useEffect(() => {
    getAllSentMessages.length < 1 &&
      dispatch(GetAllSentMessages_Json_Redux(sentObj));
  }, [dispatch]);

  const jsonObjectArray = useMemo(() => {
    return getAllSentMessages.map((item) => {
      const approvedDate = item["Date Approved"]
        ? moment(item["Date Approved"]).format("DD/MM/yyyy")
        : "Not available";
      const viewedDate = item.Viewed
        ? moment(item.Viewed).format("DD/MM/yyyy")
        : "Not available";

      let viewStatus = "Pending";
      if (!item.Viewed) viewStatus = "Unread";
      else if (item.Viewed && item.Approved === "Yes") viewStatus = "Approved";
      else if (item.Viewed && item.Approved === "No")
        viewStatus = "Disapproved";

      return {
        Subject: item.Subject || "Not available",
        Recipient: item["Client Name"] || "Not available",
        ApprovalRequested: item["To be Approved"] || "Not available",
        IssuedOn: item.Issued
          ? moment(item.Issued).format("DD/MM/yyyy")
          : "Not available",
        DueDate: item["Due Date"]
          ? moment(item["Due Date"]).format("DD/MM/yyyy")
          : "Not available",
        Status: viewStatus,
        MessageNo: item["Message No"] || "Not available",
        MessageID: item["Message ID"] || "Not available",
        ReferenceName: item["Client Name"] || "Not available",
        Section: item.Section,
        History: [
          { date: "Section", customerId: item.Section || "Not available" },
          { date: "Date Approved", customerId: approvedDate },
          { date: "Viewed On", customerId: viewedDate },
          {
            date: "Email ID",
            customerId: item.EMailId || "Not available",
          },
          {
            date: "Sent By",
            customerId: item["Sent/Received By"] || "Not available",
          },
        ],
      };
    });
  }, [getAllSentMessages]);

  useEffect(() => {
    const pendingMessages = jsonObjectArray.filter(
      (item) => item?.Status === "Pending"
    );
    setOriginalData(pendingMessages);
    setFilteredData(pendingMessages);
  }, [jsonObjectArray]);

  const paginatedData = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredData.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage, filteredData]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const sendReminderToAll = () => {
    console.log("sendReminderToAll triggered");
    let text = `${selectedItem.length} reminder emails will be sent. Do you want to continue?`;
    dispatch(
      sonamConfirmMessage(text, (confirm) => {
        if (confirm) {
          console.log("✌️confirm --->", confirm);
          SendReminderMessage();
        } else {
          console.log("✌️confirm --->", confirm);
        }
      })
    );
  };

  const CheckProgress = (res) => {
    if (progressRef?.current.length !== selectedItem.length) {
      setTimeout(() => {
        dispatch(
          ad_GetMultiReminderStatus_Json_Action(res, (newRes) => {
            // console.log("✌️res --GetMultiReminderStatus_Json->", res);
            if (Array.isArray(newRes?.Table)) {
              progressRef.current = [...newRes?.Table];
              const percent =
                (progressRef?.current.length / selectedItem.length) * 100;
              setProgressInPersent(percent);
            } else {
              console.error(
                "Error: newRes?.Table is not an array",
                newRes?.Table
              );
            }
            CheckProgress(res);
          })
        );
      }, 2000);
    } else {
      console.log("Progress complete!");
      toast.success("Progress complete!");
    }
  };

  const SendReminderMessage = () => {
    const messageNumbers =
      selectedItem.length > 0
        ? selectedItem.map((item) => item?.MessageNo).join(",")
        : ""; // In case selectedItem is empty

    dispatch(
      ad_SendMultiReminderEmail_Json_Action(messageNumbers, (res) => {
        progressRef.current = [];
        // console.log("✌️res --SendMultiReminderEmail_Json->", res);
        setSelectedItem([]);
        setProgressInPersent(0);
        CheckProgress(res);
      })
    );
  };

  return (
    <Dialog
      open={OpenPendingMessageModal}
      onClose={closeModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-modal w-100"
      maxWidth={"lg"}
    >
      <Box className="d-flex align-items-center justify-content-between modal-head">
        <Box className="clearfix">
          <DialogTitle>{"Pending Messages"}</DialogTitle>
        </Box>

        <Box>
          {selectedItem.length > 1 && (
            <Button
              className="btn-blue"
              variant="outlined"
              color="primary"
              onClick={sendReminderToAll}
              startIcon={<SendIcon />}
            >
              {`Send ${selectedItem.length} Reminders`}
            </Button>
          )}
          <Button onClick={closeModal} autoFocus>
            <CloseIcon />
          </Button>
        </Box>
      </Box>
      <DialogContent className="white-box pt-0 mt-3">
        {progressInPersent && progressRef.current.length > 0 ? (
          <Box>
            <Box className="d-flex flex-wrap gap-2">
              <LinearProgress
                value={progressInPersent}
                valueBuffer={selectedItem.length}
                variant="determinate"
                sx={{
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "green", // Progress color
                  },
                  "& .MuiLinearProgress-background": {
                    backgroundColor: "red", // Background color
                  },
                }}
                className="w-100"
              />
              <Box className="text-end w-100">
                <span>{Math.round(progressInPersent)}%</span>
              </Box>
              {/* <Box className="text-end w-100">
                <span>
                  {progressRef.current.length}/{selectedItem.length}
                </span>
              </Box> */}
            </Box>

            <Box className="mt-2">
              <DataGrid
                dataSource={progressRef.current}
                rowAlternationEnabled={true}
                showBorders={true}
                allowEllipsis={true}
                allowColumnResizing={true}
                columnResizingMode="widget"
                width="100%"
                scrolling={{
                  columnRenderingMode: "standard",
                  mode: "standard",
                  // useNative: false,
                  showScrollbar: "always"
                }}
                allowColumnReordering={true}
                columnAutoWidth={true}
                className="table-grid  dx-widget table-responsive table-height table-width"
              >
                <Column
                  caption={"Task Id"}
                  // minWidth={80}
                  // maxWidth={200}
                  cellRender={({ rowIndex, data }) => (
                    <Typography>{data.EmailTaskId}</Typography>
                  )}
                />

                <Column
                  caption="Mesage Name"
                  // minWidth={80}
                  // maxWidth={350}
                  allowFiltering={false} // Enable filtering for this column
                  cellRender={({ data }) => (
                    <Typography>{data.MesageName}</Typography>
                  )}
                />
                <Column
                  caption="Message Id"
                  // minWidth={80}
                  // maxWidth={350}
                  cellRender={({ data }) => (
                    <Typography>{data.MessageId}</Typography>
                  )}
                />

                <Column
                  caption={"Email Id"}
                  // minWidth={80}
                  // maxWidth={350}
                  cellRender={({ rowIndex, data }) => (
                    <Typography>{data.EmailId}</Typography>
                  )}
                />
                <Column
                  dataField="Status"
                  caption={"Status"}
                  className="text-end d-flex justify-comtent-end"
                  // minWidth={50}
                  // maxWidth={80}
                  allowFiltering={true} // Enable filtering for this column
                  headerFilter={{ visible: true }} // Enable header filter for this column
                  cellRender={({ data }) => {
                    return data?.Status ? <CheckIcon /> : <CancelIcon />;
                  }}
                />
                <Pager
                  allowedPageSizes={pageSizes}
                  showPageSizeSelector={true}
                />
                <Paging defaultPageSize={10} />

                <HeaderFilter visible={true} />
              </DataGrid>
            </Box>
          </Box>
        ) : paginatedData.length > 0 ? (
          <Box>
            <PendingMessageComponanat
              TableHeder={TableHeder}
              TableBodyData={paginatedData}
              setSelectedItem={setSelectedItem}
              selectedItem={selectedItem}
              originalData={originalData}
            />

            <Box className="mt-2">
              <Pagination
                count={totalPages}
                page={currentPage}
                variant="outlined"
                shape="rounded"
                onChange={handleChange}
                className="custom-pagination"
              />
            </Box>
          </Box>
        ) : (
          <CustomLoader />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PendingMesssageModal;
